import { withIcon } from "../Icon"

export const IconMinus = withIcon('<rect fill="currentColor" width="12" height="2" x="6" y="11" rx="1"/>')
